import ZButtonAction from './ZButtonAction.js';
import ZEntityContainer from '@/ZForms/parsers/entities/ZEntityContainer.js';


function getAllEnumProps(obj, propsBuffer) {
  propsBuffer = propsBuffer == null ? {} : propsBuffer;
  if (obj == null) return;
  Object.getOwnPropertyNames(obj).forEach((prop) => propsBuffer[prop] = 1);
  getAllEnumProps(Object.getPrototypeOf(obj), propsBuffer);
  return propsBuffer;
}


export default window.ZForms.registerClass('action.button.group', class ZActionGroup extends ZButtonAction {
  constructor() {
    super(...arguments);
    this.applySelectedView = 'Применить';
    this.containerProto = new ZEntityContainer();

    const myProps = getAllEnumProps(this);
    const props = Object.keys(getAllEnumProps(this.containerProto)).filter((prop) => myProps[prop] == null);
    props.forEach((prop) => this[prop] = this.containerProto[prop]);
  }

  _updateParamsFromRaw(rawData) {
    super._updateParamsFromRaw(rawData);
    this.containerProto._updateParamsFromRaw.bind(this)(rawData);
    this.applySelectedView = rawData.apply_selected_view ? rawData.apply_selected_view : this.applySelectedView;
  }

  async updateFromRaw(rawData) {
    await super.updateFromRaw(rawData);
    await this.containerProto.updateFromRaw.bind(this)(rawData);
    return this;
  }

  async parseRawEntity(rawAction) {
    rawAction.__meta__ = rawAction.__meta__ == null ? {} : rawAction.__meta__;
    rawAction.__meta__.zf_type = rawAction.__meta__.zf_type == null ? (rawAction.type == null ? 'action' : 'action.' + rawAction.type) : rawAction.__meta__.zf_type;
    return await window.ZForms.parseRaw(rawAction, this.contentMeta, this.rootEntity);
  }
});
